<template>
  <div class="appInfo-card" @click="$router.push({name:'manage app release',query:{appId:appId,appName:appName,isOwner:isOwner}})">
    <!--    应用卡片的头部（应用名、图标等）-->
    <header class="card-header" @click.stop="">
      <el-image style="position: absolute;top: 0;left: 0" :src="image.appImage"></el-image>
      <div style="position: absolute;top: 0;left: 28px;font-size: 16px">{{ appInfo.appName }}</div>
      <!--TODO  下面的图标需要改进一下体验：hover时候的颜色改变、鼠标样式的改变、必要的提示信息-->
      <div style="position: absolute;right: 0" v-if="isOwner">
        <el-tooltip effect="dark" content="应用权限管理" placement="bottom">
          <router-link :to="{name:'manage app appAuthorities',query:{appId:appInfo.appId,appName:appName}}">
            <el-image style="display: inline-block;margin-right: 5px;" :src="image.authorityImage"></el-image>
          </router-link>
        </el-tooltip>
        <el-tooltip effect="dark" content="修改应用信息" placement="bottom">
          <el-image style="display: inline-block;margin-right: 5px;cursor: pointer" :src="image.modifyImage"
                    @click="modifyAppVisible = true"></el-image>
        </el-tooltip>
        <el-tooltip effect="dark" content="删除应用" placement="bottom">
          <el-image style="cursor: pointer" :src="image.deleteImage" @click="handleDeleteAppInfo"></el-image>
        </el-tooltip>
      </div>

      <el-dialog title="修改应用" :visible.sync="modifyAppVisible">
        <el-form :model="appInfoForm" ref="modifyAppInfoForm" :rules="this.appInfoRules">
          <el-form-item label="应用名称" prop="appName">
            <el-input v-model="appInfoForm.appName"></el-input>
          </el-form-item>
          <el-form-item label="应用描述" prop="appDescribe">
            <el-input v-model="appInfoForm.appDescribe" type="textarea" :rows="5" maxlength="80"
                      show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyAppVisible = false">取 消</el-button>
          <el-button type="primary" @click="modifyApp('modifyAppInfoForm')">确 定</el-button>
        </div>
      </el-dialog>
    </header>
    <!--    应用卡片的正文（应用介绍）-->
    <article class="bc-card-context">
      {{ appInfo.appDescribe }}
    </article>
    <!--    应用卡片的尾部（时间、版本）-->
    <footer class="bc-card-footer">
      <span class="bc-card-footer-time">
        <span style="display: inline-block;margin-right: 10px">最近更新</span>
        <time>{{ appInfo.time }}</time>
      </span>
      <span class="bc-card-footer-version">
        {{ appInfo.version }}
      </span>
    </footer>
  </div>
</template>

<script>
import {deleteAppInfo, modifyAppInfo} from "@/api/AppInfo";
import {Message} from "element-ui";
import {appInfoRules} from "@/utils/common";
import {findLatelyRelease} from "@/api/AppRelease";

export default {
  name: "AppInfoCard",
  mounted() {
    this.loadReleaseData()
  },
  props: {
    appId: {
      type: Number,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    appDescribe: String,
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      image: {
        appImage: require("@/assets/应用小.png"),
        authorityImage: require("@/assets/权限.png"),
        modifyImage: require("@/assets/编辑.png"),
        deleteImage: require("@/assets/删除.png")
      },
      modifyAppVisible: false,
      appInfo: {
        appId: this.appId,
        appName: this.appName,
        appDescribe: this.appDescribe,
        version: '',
        time: ''
      },
      appInfoForm: {
        appId: this.appId,
        appName: this.appName,
        appDescribe: this.appDescribe
      },
      appInfoRules: appInfoRules
    }
  },
  methods: {
    loadReleaseData() {
      findLatelyRelease(this.appInfo.appId).then(res => {
        if (res.data !== undefined) {
          this.appInfo.version = res.data['version']
          this.appInfo.time = res.data.releaseTime
        }
      })
    },
    modifyApp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modifyAppInfo(this.appInfoForm.appId, this.appInfoForm.appName, this.appInfoForm.appDescribe).then(() => {
            this.appInfo.appName = this.appInfoForm.appName
            this.appInfo.appDescribe = this.appInfoForm.appDescribe
            Message({
              message: "成功修改应用信息",
              type: "success".duration,
              duration: 3 * 1000
            })
            this.modifyAppVisible = false
          }).catch(() => {
            this.modifyAppVisible = false
          })
        } else {
          return false;
        }
      });
    },
    handleDeleteAppInfo() {
      this.$confirm('此操作将永久删除该应用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAppInfo(this.appInfo.appId).then(() => {
          this.$message({
            type: 'success',
            message: '删除应用成功!'
          });
          this.$emit('reload-info')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style scoped>
.appInfo-card {
  width: 392px;
  height: 157px;
  padding: 17px 16px;
  border-radius: 8px;
  background-color: rgba(250, 250, 250, 1);
  box-shadow: 0px 4px 8px 0px rgba(216, 221, 226, 1);
}

.card-header {
  position: relative;
}

.bc-card-context {
  width: 360px;
  height: 60px;
  margin-top: calc(49px - 17px);
  color: rgba(102, 102, 102, 100);
  font-size: 14px;
  text-align: left;
  font-family: PingFangSC-Regular;
}

.bc-card-footer {
  margin-top: 13px;
}

.bc-card-footer-time {
  color: rgba(153, 153, 153, 100);
  font-size: 12px;
}

.bc-card-footer-version {
  float: right;
  color: rgba(102, 102, 102, 100);
  font-size: 14px;
  text-align: left;
  font-family: PingFangSC-Regular;
}

</style>
